import React from "react";
import Header from "../components/Header/Header";
import CoreAdvantage from "../components/Product/CoreAdvantage";
import OperationMode from "../components/Product/OperationMode";
import CasePresentation from "../components/Product/CasePresentation";
import Footer from "../components/Footer/Footer";
import BackToTop from "../components/BackToTop/BackToTop";

import "./Product.css";

class Product extends React.Component {
  render() {
    return (
      <div className="product">
        {/* 页头 */}
        <Header pageName="product"/>

        {/* 页头图 */}
        <img alt="图片无法显示" className="product_bkimg" src="https://hzby-devops.oss-cn-shanghai.aliyuncs.com/hzby_website/pho_banner_2_edition_2.webp" />

        {/* 核心优势 */}
        <CoreAdvantage />

        {/* 模块化产品及服务架构 */}
        <OperationMode />

        {/* 案例展示 */}
        <CasePresentation />

        {/* 页脚 */}
        <Footer />

        {/* 回到顶部 */}
        <BackToTop />
      </div>
    )
  }
}

export default Product
